import "moment/locale/pt-br";
import "react-datetime/css/react-datetime.css";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Input,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    useColorModeValue,
    useDisclosure,
} from "@chakra-ui/react";
import DateTime from "react-datetime";
import { FilterContainer } from "../../../components/Tables/FilterContainer";
import { LOCALE_PT_BR } from "constants/date-time";

export const AuditFilter = (props) => {
    const { t } = useTranslation('common');
    const { onFilter } = props;
    const { isOpen, onToggle } = useDisclosure();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [user, setUser] = useState("");
    const [ip, setIp] = useState("");
    const [url, setUrl] = useState("");
    const placeholderColor = useColorModeValue("gray.300", "gray.400");

    const isStartDateInvalid = startDate ? startDate > new Date() : false;
    const isEndDateInvalid = startDate && endDate ? endDate <= startDate : false;

    const onFilterHandler = () => {
        onFilter({
            usuario: user,
            ip: ip,
            url: url,
            data_inicial: startDate,
            data_final: endDate,
        });
    }

    const onClearHandler = () => {
        setStartDate("");
        setEndDate("");
        setUser("");
        setIp("");
        setUrl("");

        onFilter({ data_hora: null, usuario: null, ip: null, url: null });
    }

    return (
        <FilterContainer
            w='125px'
            fontSize='sm'
            fontWeight='bold'
            variant="light"
            isOpen={isOpen}
            onToggle={onToggle}
            onFilter={onFilterHandler}
            onClear={onClearHandler}
        >
            <Flex w="100%" gap="4" justify="space-between">
                <FormControl w="230px" isInvalid={isStartDateInvalid}>
                    <FormLabel>
                        {t("system.labels.start-date")}
                    </FormLabel>
                    <DateTime
                        locale={LOCALE_PT_BR}
                        closeOnSelect
                        timeFormat={false}
                        inputProps={startDate ? undefined : { value: "", placeholder: t("system.placeholders.date")}}
                        renderInput={(props) => (
                            <Input
                                {...props}
                                fontSize="sm"
                                _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                            />
                        )}
                        onChange={date => setStartDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-start-date")}
                    </FormErrorMessage>
                </FormControl>

                <FormControl w="230px" isInvalid={isEndDateInvalid}>
                    <FormLabel>
                        {t("system.labels.end-date")}
                    </FormLabel>
                    <DateTime
                        locale={LOCALE_PT_BR}
                        closeOnSelect
                        timeFormat={false}
                        inputProps={endDate ? undefined : { value: "", placeholder: t("system.placeholders.date") }}
                        renderInput={(props) => (
                            <Input
                                {...props}
                                fontSize="sm"
                                _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                            />
                        )}
                        onChange={date => setEndDate(date)} />
                    <FormErrorMessage>
                        {t("system.messages.errors.invalid-end-date")}
                    </FormErrorMessage>
                </FormControl>
            </Flex>

            <FormControl>
                <FormLabel>
                    {t("settings.audit.filter.user.label")}
                </FormLabel>
                <Input
                    fontSize="sm"
                    placeholder={t("settings.audit.filter.user.placeholder")}
                    _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                    value={user}
                    onChange={e => setUser(e.currentTarget.value)} />
            </FormControl>

            <FormControl>
                <FormLabel>
                    {t("settings.audit.filter.ip.label")}
                </FormLabel>
                <Input
                    fontSize="sm"
                    placeholder={t("settings.audit.filter.ip.placeholder")}
                    _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                    value={ip}
                    onChange={e => setIp(e.currentTarget.value)} />
            </FormControl>

            <FormControl>
                <FormLabel>
                    {t("settings.audit.filter.url.label")}
                </FormLabel>
                <Input
                    fontSize="sm"
                    placeholder={t("settings.audit.filter.url.placeholder")}
                    _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                    value={url}
                    onChange={e => setUrl(e.currentTarget.value)} />
            </FormControl>
        </FilterContainer>
    );
};